module.exports = __webpack_public_path__ + "img/background.bf7cd3f1.png";